var _path, _line, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 35,
    viewBox: "0 0 26 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2002 1.22499C5.2002 1.10073 5.30093 1 5.42519 1H20.4751C20.5994 1 20.7001 1.10073 20.7001 1.22499V10.85C20.7001 15.1301 17.2303 18.5999 12.9502 18.5999C8.66997 18.5999 5.2002 15.1301 5.2002 10.8499V1.22499Z",
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.90039,
    y1: 5.99997,
    x2: 21.0003,
    y2: 5.99997,
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8999 35C25.4522 35 25.8999 34.5523 25.8999 34V30.7001C25.8999 25.7295 21.8704 21.7001 16.8999 21.7001L9 21.7001C4.02944 21.7001 7.23028e-07 25.7295 2.8849e-07 30.7001L0 34C-4.82823e-08 34.5523 0.447715 35 1 35C1.55228 35 2 34.5523 2 34L2 30.7001C2 26.8341 5.13401 23.7001 9 23.7001L16.8999 23.7001C20.7659 23.7001 23.8999 26.8341 23.8999 30.7001V34C23.8999 34.5523 24.3476 35 24.8999 35Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0887 29.8759L7.78173 23.5761",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0889 29.8755L18.2001 23.4693",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.06f9844a2f89715c6416ce6d56832d69.svg";
export { ForwardRef as ReactComponent };